module.exports = __webpack_public_path__ + "img/AL-ONV-Logo-min.8908cffd.jpg";